import { DatePicker as AntDatePicker } from 'antd';

import { PlaceholderAsLabel } from '~shared/ui/layout';

export function DatePicker({ ...props }) {
  return (
    <PlaceholderAsLabel placeholder={props.placeholder} value={props.value}>
      <AntDatePicker {...props} size="large" />
    </PlaceholderAsLabel>
  );
}
